var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovePlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "5 5 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9482 10.4214C41.8432 10.1664 41.5936 10 41.3182 10C14.8569 10 12 20.9664 12 25.6818C12 27.3782 12.3764 28.9627 13.1196 30.3904C13.2341 30.6113 13.4605 30.7518 13.7087 30.7573C13.9432 30.7504 14.19 30.6332 14.3141 30.4164C16.1005 27.3291 21.1595 19.7091 29.5146 15.6605C29.8569 15.4968 30.266 15.6373 30.4282 15.9741C30.5918 16.3137 30.45 16.7228 30.1119 16.8864C29.4819 17.1919 28.8764 17.5246 28.2832 17.8696C28.0569 18.0018 27.8373 18.1423 27.6151 18.28C27.281 18.4873 26.951 18.6986 26.6292 18.9168C26.3087 19.1323 25.9923 19.3532 25.6814 19.5796C25.5846 19.6505 25.4919 19.7228 25.3964 19.795C17.0809 25.9914 12 35.8763 12 39.3182C12 39.6946 12.3055 40 12.6818 40C13.0582 40 13.3637 39.6946 13.3637 39.3182C13.3637 38.2191 14.1123 35.991 15.5291 33.3332C17.5855 35.0146 20.3523 35.9091 23.591 35.9091C32.3468 35.9091 34.181 27.5773 35.1655 23.1005C36.4909 17.0759 39.4078 13.5564 41.7996 11.1632C41.996 10.9682 42.0532 10.6763 41.9482 10.4214Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36L13 13",
    stroke: "#ED3431",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 16,
    stroke: "#ED3431",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePlant);
export default __webpack_public_path__ + "static/media/Remove-Plant.3a91d5cb09faea426413731424f08a0e.svg";
export { ForwardRef as ReactComponent };